import type { InstructionIconKey } from "@/types/instruction-content";

/**
 * Icon tiles for the instruction moves, served from `public/assets/icons/instructions`.
 *
 * Referenced by URL string (not a bundler import) — matches how the result
 * screen's stage icons are already wired in this app.
 */
export const INSTRUCTION_ICONS: Record<InstructionIconKey, string> = {
  tickCircle: "/assets/icons/instructions/tick-circle.svg",
  closeCircle: "/assets/icons/instructions/close-circle.svg",
  winner: "/assets/icons/instructions/winner.svg",
  danger: "/assets/icons/instructions/danger.svg",
};
